// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchBar_container__1NLnq"};